import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

declare let ga: any;
declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsEventsService {
  measurement_id = 'G-CW5YDT5Z52';
  initGAFlag: boolean = false;
  constructor(public router: Router) { 
  }
  
  public eventEmitter(
    eventName: string,
    eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null
  ){
    if(eventValue ==null){
      gtag('event', eventAction, {
        event_category: eventCategory,
        event_label: eventLabel
      });
    }
    else{
      gtag('event', eventAction, {
        event_category: eventCategory,
        event_label: eventLabel,
        value: eventValue
      });
    }
  }

  setUserProperty(cName){
    gtag('set', 'user_properties', {
      client_name: cName
    });

  }

  setDimensionValue(prpty, value){
    switch (prpty) {
      case "client_skinTone":
        gtag('set', 'user_properties', {
          selfie_skin_tone: value
        });  
        break;

      case "client_acne":
        gtag('set', 'user_properties', {
          selfie_acne: value
        }); 
        break;

      case "client_gender":
        gtag('set', 'user_properties', {
          selfie_gender: value
        });  
        break;

      case "client_hair_color":
        gtag('set', 'user_properties', {
          selfie_hair_color: value
        }); 
        break;
      
      case "client_age": 
        gtag('set', 'user_properties', {
          selfie_age: value
        });  
        break;
      
      case "client_wavy_hair":
        gtag('set', 'user_properties', {
          selfie_wavy_hair: value
        }); 
        break;
      
      case "client_grayHair":
        gtag('set', 'user_properties', {
          selfie_gray_hair: value
        }); 
        break;
    
      case "client_straight_hair":
        gtag('set', 'user_properties', {
          selfie_straight_hair: value
        }); 
        break;
        
      case "client_heavyMakeup":
        gtag('set', 'user_properties', {
          selfie_heavy_makeup: value
        }); 
        break;
        
      case "client_baldness":
        gtag('set', 'user_properties', {
          selfie_baldness: value
        }); 
        break;
        
      default:
        break;
    }
    
  }

  sentToGAView(title, path){
    gtag('event', 'page_view', {
      'page_title' : title,
      'page_path': path,
      'page_location': path
    });
  }

  loadGA(trackingID){
    let gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${ trackingID }`);

    let gaScript2 = document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${ trackingID }\',{\'cookie_domain\': \'a.tangent.ai\',\'cookie_flags\': \'SameSite=None;Secure\'});`;

    document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }

}
